import { ITheme } from '@/store/theme/interface'

export const themeConfig: ITheme = {
	sidebarStyle: 'light', // 中科维德 icc
	headerStyle: 'theme', // 中科维德 icc
	primaryColor: '#3E8EF7', //中科伟德#3b5ed6
	layout: 'vertical',
	uniqueOpened: true,
	isLogo: true,
	isBreadcrumb: true,
	isTabsView: true,
	isTabsCache: true,
	tabsStyle: 'style-2',
	defaultPlatform: 'intelligent', // 可选值: intelligent(智能运维平台), lifecycle(设备全生命周期)
	platType: 1, // 可选值: 0(默认风格), 1(智能运维风格)
	isLayoutView: true,
	isDark: false,
	isSettings: false,
	themeType: 'light' // 可选值: light(明亮)、dark(暗黑)、blue(蓝)、bluex(蓝X)
}
